import { RequestService } from './RequestService';
import axios from 'axios';

const getApiUrl = () =>
    (window._env_ && window._env_.REACT_APP_API_URL) || process.env.REACT_APP_API_URL || 'http://localhost:8080';

export class RecitalService extends RequestService {
    constructor() { super('api'); }

    getRecitals   = ()        => this.request('GET',    'recitals');
    getRecital    = (id)      => this.request('GET',    `recitals/${id}`);
    createRecital = (body)    => this.request('POST',   'recitals',  '', body);
    updateRecital = (id, body)=> this.request('PATCH',  `recitals/${id}`, '', body);
    deleteRecital = (id)      => this.request('DELETE', `recitals/${id}`);

    addShow    = (recitalId, body) => this.request('POST',   `recitals/${recitalId}/shows`, '', body);
    updateShow = (showId, body)    => this.request('PATCH',  `shows/${showId}`, '', body);
    deleteShow = (showId)          => this.request('DELETE', `shows/${showId}`);

    addAct      = (showId, body)              => this.request('POST',   `shows/${showId}/acts`, '', body);
    reorderActs = (showId, orderedActIds)     => this.request('PATCH',  `shows/${showId}/acts/reorder`, '', { orderedActIds });
    updateAct   = (actId, body)               => this.request('PATCH',  `acts/${actId}`, '', body);
    deleteAct   = (actId)                     => this.request('DELETE', `acts/${actId}`);
    // Move an act to an exact spot, within its show or into another show of the same recital.
    moveAct     = (actId, toShowId, position) => this.request('PATCH',  `acts/${actId}/move`, '', { toShowId, position });

    // Snapshot more schedule classes into the recital as independent copies
    importClasses = (recitalId, body) => this.request('POST', `recitals/${recitalId}/classes/import`, '', body);

    // Routines: recital-only classes (opening number, finale) with their own roster.
    createRoutine   = (recitalId, body) => this.request('POST',  `recitals/${recitalId}/routines`, '', body);
    updateRoutine   = (classId, body)   => this.request('PATCH', `recital-classes/${classId}`, '', body);
    parseRoutineXls = (recitalId, file) => {
        const formData = new FormData();
        formData.append('file', file);
        return this.request('POST', `recitals/${recitalId}/routines/parse-xls`, '', formData, null, true);
    };

    getBoards  = ()         => this.request('GET', 'recital-boards');
    getClasses = (boardId) => this.request('GET', boardId ? `recital-classes?boardId=${boardId}` : 'recital-classes');

    // Blob downloads bypass RequestService (needs responseType blob)
    // levelNames: {level color string → level name} — sticker levels store
    // colors, so the server needs this map to print readable level names.
    exportPdf = (showId, colorBy, colorMap, levelNames = {}) => axios({
        method: 'GET',
        url: `${getApiUrl()}/api/shows/${showId}/export/pdf`,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') },
        params: { colorBy, colorMap: JSON.stringify(colorMap), levelNames: JSON.stringify(levelNames) },
        responseType: 'blob',
    });

    exportXls = (showId, colorBy, colorMap, levelNames = {}) => axios({
        method: 'GET',
        url: `${getApiUrl()}/api/shows/${showId}/export/xls`,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') },
        params: { colorBy, colorMap: JSON.stringify(colorMap), levelNames: JSON.stringify(levelNames) },
        responseType: 'blob',
    });
}

export const recitalService = new RecitalService();
